module.exports = __webpack_public_path__ + "static/img/17ok.ce1a19bd.webp";